import React from 'react';

const debug = false
// const debug = "FieldProto_PickerValueNotEmpty"

export default function FieldProto_PickerValueNotEmpty(props:any) {

    // search for '_PickerValueNotEmpty' for examples...

    debug && console.log(debug, 'render', props)

    return (
        <div className="ui5-field-picker" onClick={props.onClick}>
            <div className={Classes("icon", props.field.icon, props.configOptions?.iconClass || props.options?.iconClass)}/>
            {props.children}
        </div>
    )

}
